import * as React from "react";
import styled from "styled-components";
import useHistory from "routing/useHistory";
import SecurityRoutes from "security-app/routing/Routes";
import { Button } from "components/bootstrap";
import { Row } from "common/components";
const TabsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 7px;
  padding: 7px;
  background-color: ${({ theme }) => theme.colors.global.background};
  border-radius: 6px;
  width: 200px;
`;
function EventProcedureTabs({ viewType }) {
  const { push } = useHistory();
  const procedureRoute = SecurityRoutes.CORE_EVENTS.EVENT_PROCEDURES.LIST("procedures");
  const stepRoute = SecurityRoutes.CORE_EVENTS.EVENT_PROCEDURES.LIST("steps");
  return /* @__PURE__ */ React.createElement(TabsContainer, null, /* @__PURE__ */ React.createElement(Row, { $align: "center", $gap: "sm" }, /* @__PURE__ */ React.createElement(
    Button,
    {
      bsStyle: viewType === "procedures" ? "primary" : "default",
      bsSize: "small",
      onClick: () => push(procedureRoute)
    },
    "Event Procedures"
  ), /* @__PURE__ */ React.createElement(Button, { bsStyle: viewType === "steps" ? "primary" : "default", bsSize: "small", onClick: () => push(stepRoute) }, "Steps")));
}
export default EventProcedureTabs;
